/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldChangeResponse } from './FieldChangeResponse';
import {
    FieldChangeResponseFromJSON,
    FieldChangeResponseFromJSONTyped,
    FieldChangeResponseToJSON,
    FieldChangeResponseToJSONTyped,
} from './FieldChangeResponse';
import type { EntitySubtypeResponse } from './EntitySubtypeResponse';
import {
    EntitySubtypeResponseFromJSON,
    EntitySubtypeResponseFromJSONTyped,
    EntitySubtypeResponseToJSON,
    EntitySubtypeResponseToJSONTyped,
} from './EntitySubtypeResponse';
import type { ChangeEntryKind } from './ChangeEntryKind';
import {
    ChangeEntryKindFromJSON,
    ChangeEntryKindFromJSONTyped,
    ChangeEntryKindToJSON,
    ChangeEntryKindToJSONTyped,
} from './ChangeEntryKind';

/**
 * 
 * @export
 * @interface ClientChangeHistoryEntryResponse
 */
export interface ClientChangeHistoryEntryResponse {
    /**
     * 
     * @type {Date}
     * @memberof ClientChangeHistoryEntryResponse
     */
    changedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeHistoryEntryResponse
     */
    userCode: string;
    /**
     * 
     * @type {ChangeEntryKind}
     * @memberof ClientChangeHistoryEntryResponse
     */
    kind: ChangeEntryKind;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeHistoryEntryResponse
     */
    entityType: string;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeHistoryEntryResponse
     */
    entityName: string | null;
    /**
     * 
     * @type {EntitySubtypeResponse}
     * @memberof ClientChangeHistoryEntryResponse
     */
    entitySubtype: EntitySubtypeResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientChangeHistoryEntryResponse
     */
    isIdentifiedByEntityType: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeHistoryEntryResponse
     */
    entityValue: string | null;
    /**
     * 
     * @type {Array<FieldChangeResponse>}
     * @memberof ClientChangeHistoryEntryResponse
     */
    fieldChanges: Array<FieldChangeResponse>;
}



/**
 * Check if a given object implements the ClientChangeHistoryEntryResponse interface.
 */
export function instanceOfClientChangeHistoryEntryResponse(value: object): value is ClientChangeHistoryEntryResponse {
    if (!('changedAtUtc' in value) || value['changedAtUtc'] === undefined) return false;
    if (!('userCode' in value) || value['userCode'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('entitySubtype' in value) || value['entitySubtype'] === undefined) return false;
    if (!('isIdentifiedByEntityType' in value) || value['isIdentifiedByEntityType'] === undefined) return false;
    if (!('entityValue' in value) || value['entityValue'] === undefined) return false;
    if (!('fieldChanges' in value) || value['fieldChanges'] === undefined) return false;
    return true;
}

export function ClientChangeHistoryEntryResponseFromJSON(json: any): ClientChangeHistoryEntryResponse {
    return ClientChangeHistoryEntryResponseFromJSONTyped(json, false);
}

export function ClientChangeHistoryEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientChangeHistoryEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'changedAtUtc': (new Date(json['changedAtUtc'])),
        'userCode': json['userCode'],
        'kind': ChangeEntryKindFromJSON(json['kind']),
        'entityType': json['entityType'],
        'entityName': json['entityName'],
        'entitySubtype': EntitySubtypeResponseFromJSON(json['entitySubtype']),
        'isIdentifiedByEntityType': json['isIdentifiedByEntityType'],
        'entityValue': json['entityValue'],
        'fieldChanges': ((json['fieldChanges'] as Array<any>).map(FieldChangeResponseFromJSON)),
    };
}

export function ClientChangeHistoryEntryResponseToJSON(json: any): ClientChangeHistoryEntryResponse {
    return ClientChangeHistoryEntryResponseToJSONTyped(json, false);
}

export function ClientChangeHistoryEntryResponseToJSONTyped(value?: ClientChangeHistoryEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changedAtUtc': value['changedAtUtc'].toISOString(),
        'userCode': value['userCode'],
        'kind': ChangeEntryKindToJSON(value['kind']),
        'entityType': value['entityType'],
        'entityName': value['entityName'],
        'entitySubtype': EntitySubtypeResponseToJSON(value['entitySubtype']),
        'isIdentifiedByEntityType': value['isIdentifiedByEntityType'],
        'entityValue': value['entityValue'],
        'fieldChanges': ((value['fieldChanges'] as Array<any>).map(FieldChangeResponseToJSON)),
    };
}

